import { LocationType, Type } from "../../Models/GeocodeResponse.js";

export class GtfsService {
  /**
   * Determines if a feature is of type GTFS or not.
   *
   * @param {Feature<Point, any>} feature Feature
   * @returns {boolean} Returns true if feature is of type GTFS, false otherwise.
   */
  static isFeatureGtfs(feature) {
    return feature.properties.type === Type.GTFS;
  }

  /**
   * Determines if a feature is a GTFS station or not.
   *
   * @param {Feature<Point, any>} feature Feature
   * @returns {boolean} Returns true if feature is a GTFS station, false otherwise.
   */
  static isFeatureStation(feature) {
    const { locationType, type } = feature.properties;
    return type === Type.GTFS && locationType === LocationType.STATION;
  }
}
